import React, { useEffect } from 'react';
import { WomensSelfDefenseNavigation } from './womens-self-defense/WomensSelfDefenseNavigation';
import { WomensSelfDefenseHeader } from './womens-self-defense/WomensSelfDefenseHeader';
import { WomensSelfDefenseContent } from './womens-self-defense/WomensSelfDefenseContent';
import { WomensSelfDefenseFooter } from './womens-self-defense/WomensSelfDefenseFooter';
export function WomensSelfDefensePage() {
  useEffect(() => {
    document.title = "Women's Self-Defense Seminar April 18, 2026 | Walker's Martial Arts";
  }, []);
  return <div className="bg-black min-h-screen" data-id="element-2135">
      <WomensSelfDefenseNavigation data-id="element-2136" />
      <WomensSelfDefenseHeader data-id="element-2137" />
      <WomensSelfDefenseContent data-id="element-2138" />
      <WomensSelfDefenseFooter data-id="element-2139" />
    </div>;
}